<div class="container me-quick-test">
    <div *ngIf="data">
        <div class="row d-flex flex-column-reverse flex-lg-row">
            <div class="col-md-6 col-xs-12 me-quick-test--block" >
                <div class="me-quick-test--title hero" [innerHTML]="data.headline | storyblokRichtext">
                </div>
                <div *ngIf="data.hero" class="me-quick-test--line"></div>
                <div class="me-quick-test--description hero" [innerHTML]="data.text | storyblokRichtext"></div>
            </div>
            <div class="col-md-6 col-xs-12">
                <div class="me-quick-test--image">
                    <img src="{{data.image.filename}}" >
                </div>
            </div>
        </div>
        <div class="me-quick-test--body">
            <div class="me-quick-test--body--text" [innerHTML]="description | storyblokRichtext"></div>
        </div>
    </div>
</div>

<div bsModal #modal="bs-modal" class="modal fade video-form" tabindex="-1" role="dialog" aria-hidden="false">
    <div class="modal-dialog me-quick-test">
        <div class="modal-content" *ngIf="question">
            <i class="btn fas fa-times close-btn" (click)="this.modal.hide()"></i>
            <div class="me-quick-test--question">
                <div class="me-quick-test--question--text">
                    {{question.text}}
                </div>
                <div class="me-quick-test--question--rating">
                    <div class="me-quick-test--question--rating--block mat-slider">
                        <mat-slider showTickMarks 
                            class="mat-slider--rating mat-slider--rating__me"
                            [(ngModel)]="rating"
                        >
                        </mat-slider>
                        <div class="mt-2">
                            <label>
                                <span class="me-quick-test--question--rating--block--emoji">😁</span>
                                <span class="me-quick-test--question--rating--block--label">{{ 'does not apply' | translate}}</span>
                            </label>
                            <label class="pull-right">
                                <span class="me-quick-test--question--rating--block--label">{{ 'applies' | translate}}</span>
                                <span class="me-quick-test--question--rating--block--emoji">😢</span>
                            </label>
                        </div>
                    </div>
                    <div class="me-quick-test--question--rating--btn">
                        <button class="btn btn--primary btn-active-me" (click)="next()">
                            {{ 'Continue' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>